// Pill tabs for home sections: [role=tab] buttons inside <ns-tabs> show the panel named by aria-controls.

export function nextTab(index, key, count) {
  if (key === 'ArrowRight') return (index + 1) % count;
  if (key === 'ArrowLeft') return (index - 1 + count) % count;
  if (key === 'Home') return 0;
  if (key === 'End') return count - 1;
  return index;
}

if (typeof customElements !== 'undefined' && !customElements.get('ns-tabs')) {
  customElements.define('ns-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.onClick = event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab), false);
      };
      this.onKey = event => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index < 0) return;
        const next = nextTab(index, event.key, this.tabs.length);
        if (next === index) return;
        event.preventDefault();
        this.select(next, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }
    select(index, focus) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
    }
  });
}
